import React from 'react';
import { CommonFilterProps } from './types';
import { FilterBase } from './FilterBase';
import { mapFilterKey, getActivedFilterLabels } from '../utils';
import {
  ColorMenu,
  MotifMenu,
  MagnetMenu,
  CustomPhotoMenu,
  CustomFoilMenu,
  ShapeMenu,
  FeaturedArtistMenu,
  LetterpressMenu,
  OrientationMenu,
  ReceptionMenu,
} from '../../MenusV2';

interface FilterMenuProps extends Omit<CommonFilterProps, 'activeFilter'> {
  filter: any;
}

const FilterMenu: React.FC<FilterMenuProps> = ({ filter, updateFilter, searchFilters }) => {
  const { filterStateKey, optionList, individualVisibilityCheck, cardType } = filter;
  const activeValue = filterStateKey ? searchFilters[mapFilterKey(filterStateKey)] : undefined;
  console.log(filter);

  const booleanFilterProps = {
    activeValue: activeValue as boolean,
    updateFilter,
  };
  const arrayFilterProps = {
    optionList,
    activeValue: activeValue as string[],
    updateFilter,
  };

  switch (filter.label) {
    case 'Color':
      return <ColorMenu {...arrayFilterProps} />;
    case 'Style':
    case 'Occasion':
      return <MotifMenu {...arrayFilterProps} />;
    case 'Magnet':
      return <MagnetMenu {...booleanFilterProps} />;
    case 'Photo':
    case 'Custom Photo':
      return (
        <CustomPhotoMenu
          activeFilters={searchFilters}
          updateFilter={updateFilter}
          individualVisibilityCheck={individualVisibilityCheck}
        />
      );
    case 'Foil':
      return <CustomFoilMenu {...booleanFilterProps} />;
    case 'Shape':
      return <ShapeMenu {...arrayFilterProps} />;
    case 'Letterpress':
      return <LetterpressMenu {...booleanFilterProps} />;
    case 'Reception Only':
      return <ReceptionMenu {...booleanFilterProps} />;
    case 'Orientation':
      return (
        <OrientationMenu
          activeFilters={searchFilters}
          updateFilter={updateFilter}
          cardType={cardType}
        />
      );
    case 'Artist':
    case 'Featured Artist':
      return <FeaturedArtistMenu {...booleanFilterProps} />;
    default:
      return null;
  }
};

interface FilterItemProps extends CommonFilterProps {
  filter: any;
}

export const FilterItem: React.FC<FilterItemProps> = ({
  filter,
  updateFilter,
  activeFilter,
  searchFilters,
}) => {
  const { filterStateKey } = filter;

  return (
    <FilterBase
      filterLabel={filter.label}
      filterCount={filter?.numSelected()}
      filterSelectedOptions={getActivedFilterLabels(searchFilters, filterStateKey)}
      activeFilter={activeFilter}
    >
      <FilterMenu filter={filter} updateFilter={updateFilter} searchFilters={searchFilters} />
    </FilterBase>
  );
};
